export default {
  // Header
  'nav.home': 'Ana Sayfa',
  'nav.services': 'Hizmetler',
  'nav.about': 'Hakkımızda',
  'nav.process': 'Süreç',
  'nav.testimonials': 'Referanslar',
  'nav.contact': 'İletişim',
  'nav.whyUs': 'Neden Biz?',
  'nav.portfolio': 'Projeler',
  'nav.careers': 'Bizimle Çalışın',

  // Hero
  'hero.title': 'Profesyonel Ticari Temizlik Hizmetleri',
  'hero.subtitle': '2008\'den beri hastaneler, alışveriş merkezleri ve inşaat sonrası alanlar için güvenilir ve yüksek kaliteli temizlik çözümleri sunuyoruz',
  'hero.cta': 'Ücretsiz Teklif Alın',
  'hero.phone': 'Hemen Arayın',

  // Services
  'services.title': 'Hizmetlerimiz',
  'services.subtitle': 'Her ihtiyaca yönelik kapsamlı temizlik çözümleri',
  'services.hospital.title': 'Hastane Temizliği',
  'services.hospital.desc': 'Sıkı hijyen protokolleri ve sertifikalı personel ile özel tıbbi tesis temizliği',
  'services.mall.title': 'Alışveriş Merkezi Temizliği',
  'services.mall.desc': 'Perakende alanları, yemek katları ve ortak alanlar için eksiksiz temizlik hizmetleri',
  'services.construction.title': 'İnşaat Sonrası Temizlik',
  'services.construction.desc': 'İnşaat veya tadilat projelerinden sonra kapsamlı temizlik ve moloz kaldırma',
  'services.office.title': 'Ofis Temizliği',
  'services.office.desc': 'Kurumsal ofisler ve iş merkezleri için günlük veya periyodik temizlik hizmetleri',
  'services.industrial.title': 'Endüstriyel Temizlik',
  'services.industrial.desc': 'Fabrikalar, depolar ve endüstriyel tesisler için ağır hizmet temizliği',
  'services.residential.title': 'Konut Temizliği',
  'services.residential.desc': 'Derin temizlik ve düzenli bakım dahil profesyonel ev temizlik hizmetleri',

  // Why Choose Us
  'why.title': 'Neden Roba Temizlik?',
  'why.subtitle': 'Profesyonel temizlik hizmetleri için güvenilir ortağınız',
  'why.experience.title': 'Yıllık Deneyim',
  'why.experience.desc': '2008\'den beri kanıtlanmış uzmanlıkla hizmet veriyoruz',
  'why.certified.title': 'Sertifikalı Ekip',
  'why.certified.desc': 'Tam eğitimli ve sertifikalı temizlik profesyonelleri',
  'why.eco.title': 'Çevre Dostu Ürünler',
  'why.eco.desc': 'Çevreye güvenli temizlik çözümleri kullanıyoruz',
  'why.support.title': '7/24 Destek',
  'why.support.desc': 'Acil temizlik hizmetleri her zaman mevcut',
  'why.insured.title': 'Lisanslı ve Sigortalı',
  'why.insured.desc': 'Huzurunuz için tam sorumluluk sigortası',
  'why.quality.title': 'Kalite Garantisi',
  'why.quality.desc': 'Tüm hizmetlerde %100 memnuniyet garantisi',

  // Process
  'process.title': 'Sürecimiz',
  'process.subtitle': 'Tertemiz alanlara giden basit adımlar',
  'process.step1.title': 'Bize Ulaşın',
  'process.step1.desc': 'Telefon veya iletişim formu ile ulaşın',
  'process.step2.title': 'Alan Değerlendirmesi',
  'process.step2.desc': 'Temizlik ihtiyaçlarınızı ziyaret edip değerlendiriyoruz',
  'process.step3.title': 'Özel Teklif',
  'process.step3.desc': 'Size özel hazırlanmış detaylı bir teklif alın',
  'process.step4.title': 'Profesyonel Hizmet',
  'process.step4.desc': 'Sertifikalı ekibimiz olağanüstü sonuçlar sunar',

  // Testimonials
  'testimonials.title': 'Referanslarımız',
  'testimonials.subtitle': 'İstanbul\'un önde gelen kuruluşları tarafından güveniliyor',
  'testimonials.client1.name': 'Dr. Mehmet Yılmaz',
  'testimonials.client1.position': 'Hastane Müdürü',
  'testimonials.client1.text': 'Roba Temizlik 5 yıldır hastanemizin bakımını yapıyor. Hijyen standartlarına gösterdikleri özen ve profesyonellikleri olağanüstü. Kesinlikle tavsiye ederim!',
  'testimonials.client2.name': 'Ayşe Demir',
  'testimonials.client2.position': 'AVM Müdürü',
  'testimonials.client2.text': 'Büyük bir alışveriş merkezi yönetiyoruz ve Roba Temizlik tüm temizlik ihtiyaçlarımızı mükemmel şekilde karşılıyor. Ekipleri güvenilir ve verimli.',
  'testimonials.client3.name': 'Can Öztürk',
  'testimonials.client3.position': 'İnşaat Müdürü',
  'testimonials.client3.text': 'Her projeden sonra Roba Temizlik inşaat sahalarımızı tertemiz alanlara dönüştürüyor. İnşaat sonrası temizlikleri olağanüstü.',

  // Service Areas
  'areas.title': 'Hizmet Bölgeleri',
  'areas.subtitle': 'İstanbul\'un tüm ilçelerine hizmet veriyoruz',
  'areas.european': 'Avrupa Yakası',
  'areas.asian': 'Anadolu Yakası',
  'areas.all': 'Tüm İstanbul İlçeleri',

  // Portfolio
  'portfolio.title': 'Projelerimiz',
  'portfolio.subtitle': 'Uzmanlığımızı sergileyen son çalışmalar',
  'portfolio.project1.title': 'Özel Hastane - Beşiktaş',
  'portfolio.project1.desc': 'Özel protokollerle eksiksiz tıbbi tesis temizliği',
  'portfolio.project2.title': 'Alışveriş Merkezi - Kadıköy',
  'portfolio.project2.desc': '15.000 m² perakende alanı günlük bakım',
  'portfolio.project3.title': 'Ofis Kompleksi - Maslak',
  'portfolio.project3.desc': '500+ çalışan için kurumsal ofis temizliği',
  'portfolio.project4.title': 'Konut Kompleksi - Ataşehir',
  'portfolio.project4.desc': '200 daire için inşaat sonrası temizlik',

  // CTA
  'cta.title': 'Profesyonel Temizliği Deneyimlemeye Hazır mısınız?',
  'cta.subtitle': 'Bugün ücretsiz teklifinizi alın ve Roba Temizlik farkını keşfedin',
  'cta.button': 'Ücretsiz Teklif İsteyin',

  // Contact
  'contact.title': 'İletişim',
  'contact.subtitle': 'Ücretsiz danışmanlık için bizimle iletişime geçin',
  'contact.name': 'Ad Soyad',
  'contact.email': 'E-posta Adresi',
  'contact.phone': 'Telefon Numarası',
  'contact.service': 'Hizmet Türü',
  'contact.service.select': 'Bir hizmet seçin',
  'contact.service.hospital': 'Hastane Temizliği',
  'contact.service.mall': 'Alışveriş Merkezi Temizliği',
  'contact.service.construction': 'İnşaat Sonrası Temizlik',
  'contact.service.office': 'Ofis Temizliği',
  'contact.service.industrial': 'Endüstriyel Temizlik',
  'contact.service.residential': 'Konut Temizliği',
  'contact.message': 'Mesajınız',
  'contact.submit': 'Mesaj Gönder',
  'contact.sending': 'Gönderiliyor...',
  'contact.success': 'Teşekkürler! En kısa sürede sizinle iletişime geçeceğiz.',
  'contact.error': 'Bir hata oluştu. Lütfen tekrar deneyin.',
  'contact.info.title': 'İletişim Bilgileri',
  'contact.info.address': 'Adres',
  'contact.info.phone': 'Telefon',
  'contact.info.email': 'E-posta',
  'contact.info.hours': 'Çalışma Saatleri',
  'contact.info.hours.value': 'Pazartesi - Pazar: 7/24',

  // Careers
  'careers.title': 'Bizimle Çalışın',
  'careers.subtitle': 'Roba Temizlik ailesinin bir parçası olun',
  'careers.description': 'Profesyonel ekibimize katılmak ister misiniz? Roba Temizlik şirketinde temizlik işçisi olarak çalışmak isterseniz bu formu doldurun, sizinle iletişime geçelim.',
  'careers.form.title': 'İş Başvuru Formu',
  'careers.form.name': 'Ad Soyad',
  'careers.form.name.placeholder': 'Adınızı ve soyadınızı girin',
  'careers.form.phone': 'Telefon Numarası',
  'careers.form.phone.placeholder': 'Telefon numaranızı girin',
  'careers.form.about': 'Kendiniz Hakkında',
  'careers.form.about.placeholder': 'Deneyimleriniz, yetenekleriniz ve neden bizimle çalışmak istediğiniz hakkında bilgi verin... (Maksimum 500 karakter)',
  'careers.form.submit': 'Başvuruyu Gönder',
  'careers.form.sending': 'Gönderiliyor...',
  'careers.form.success': 'Başvurunuz alındı! En kısa sürede sizinle iletişime geçeceğiz.',
  'careers.form.error': 'Bir hata oluştu. Lütfen tekrar deneyin.',
  'careers.benefits.title': 'Neden Bizimle Çalışmalısınız?',
  'careers.benefit1.title': 'Rekabetçi Maaş',
  'careers.benefit1.desc': 'Sektörün en iyi ücret paketleri',
  'careers.benefit2.title': 'Eğitim Programları',
  'careers.benefit2.desc': 'Sürekli gelişim ve sertifikasyon imkanları',
  'careers.benefit3.title': 'Sosyal Haklar',
  'careers.benefit3.desc': 'Sigorta ve ek sosyal haklar',
  'careers.benefit4.title': 'Kariyer Gelişimi',
  'careers.benefit4.desc': 'Terfi ve ilerleme fırsatları',

  // Footer
  'footer.description': '2008\'den beri İstanbul\'da profesyonel ticari temizlik hizmetleri sunuyoruz.',
  'footer.quickLinks': 'Hızlı Bağlantılar',
  'footer.services': 'Hizmetlerimiz',
  'footer.contact': 'İletişim',
  'footer.rights': 'Tüm hakları saklıdır.',
  'footer.privacy': 'Gizlilik Politikası',
  'footer.terms': 'Kullanım Koşulları',
  'footer.about.title': 'Roba Temizlik Hakkında',
  'footer.about.text': '2008\'den beri İstanbul\'da profesyonel ticari temizlik hizmetleri. Hastaneler, alışveriş merkezleri, ofisler ve daha fazlası için güvenilir, yüksek kaliteli temizlik çözümleri sunuyoruz.',
  'footer.services.title': 'Hizmetler',
  'footer.quick.title': 'Hızlı Bağlantılar',
  'footer.contact.title': 'İletişim',
  'footer.powered': 'Website Builder',
};
